// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuSearch_wrapper__5UGAk","closeIconButton":"MenuSearch_closeIconButton__InTdk"};